module.exports = __webpack_public_path__ + "static/enterprise.aa4ace8a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/enterprise.svg
// module id = 459
// module chunks = 226020273838829